import type { AxiosInstance } from 'axios';
import { attachAuth } from './auth';
import { createErrorInterceptor } from './error';

/** Installs the request and response interceptors. Called once per client, from `client.ts`. */
export const installInterceptors = (client: AxiosInstance) => {
  client.interceptors.request.use(attachAuth);
  client.interceptors.response.use((response) => response, createErrorInterceptor(client));
};
